<template>
    <div>
        <v-autocomplete
                v-model="role"
                :items="roleStore.roles"
                item-value="id"
                item-text="name"
                outlined
                dense
                :chips="multiple"
                :deletable-chips="!readonly"
                :label="label"
                :color="inputColor"
                :background-color="backgroundColor"
                :readonly="readonly"
                :multiple="multiple"
                :loading="loading"
                :clearable="!readonly"
                @input="input"
                :rules="rules"
                hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import {useRoleStore} from "@/stores/Setting/Role";
import axios from "axios";

export default {
    name: "StrRoleAutocomplete",
    props: {
        value: [Number, Array],
        readonly: Boolean,
        multiple: Boolean,
        label: String,
        rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const roleStore = useRoleStore();

        const role = ref(null);

        function findAll() {
            loading.value  = true;
            axios.get(`/roles`).then(response => {
                roleStore.setRoles(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        function input(value) {
            emit('input', value)
        }

        watch(() => props.value, () => {
            role.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            roleStore,
            loading,
            inputColor,
            backgroundColor,
            role,
            input,
        }
    }
}
</script>

<style scoped>

</style>